import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import AllProviders from "./context/AllProviders";
import ErrorBoundary from "./components/ErrorBoundary"; // à créer si non existant

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("❌ Élément racine #root introuvable dans index.html");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AllProviders>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </AllProviders>
    </BrowserRouter>
  </React.StrictMode>
);
// HOT_RELOAD_TEST Tue 26 Aug 2025 09:44:03 AM UTC
